import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from './models/configuration.model';
import { CursorService } from './services/cursor.service';
import { MultimodalService } from './services/multimodal.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})


export class AppComponent {
  title = 'eve-hoggan';
  page = '';

  config: Config;

  constructor(private cursorService: CursorService, private router: Router, private multimodalService: MultimodalService) {
    this.config = this.multimodalService.config;
  }



  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    // change cursor when hovering clickable elements only when visual feedback is available
    if (this.multimodalService.config.modalities[1].active) {
      if (this.multimodalService.config.modalities[1].active && (e.target as HTMLElement).classList.contains('buttonEl')) {
        this.cursorService.moveCursor(e.pageX, e.pageY, true);
      } else {
        this.cursorService.moveCursor(e.pageX, e.pageY, false);
      }
    }
  }

  



}


